export default {
  eagle: {
    apiKey: 'AIzaSyDbTF9hx8jFbSuH2AnGVVhvnGc6QoU83eI',
    authDomain: 'bageleyes.firebaseapp.com',
    databaseURL: 'https://bageleyes.firebaseio.com',
    projectId: 'firebase-bageleyes',
    storageBucket: 'firebase-bageleyes.appspot.com',
    messagingSenderId: '461268858567'
  },
  'evo-ip': {
    apiKey: 'AIzaSyDueOfsCj6wLVBLC5jlWA9t2XVfHgYoPa4',
    authDomain: 'evo-ipip.firebaseapp.com',
    databaseURL: 'https://evo-ipip.firebaseio.com',
    projectId: 'evo-ipip'
  }
}



// WEBPACK FOOTER //
// ./src/firebaseRef.js